var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
var Loader = function () {
    return (_jsx("div", __assign({ className: 'showbox' }, { children: _jsx("div", __assign({ className: 'loader' }, { children: _jsx("svg", __assign({ className: 'circular', viewBox: '25 25 50 50' }, { children: _jsx("circle", { className: 'path', cx: '50', cy: '50', r: '20', fill: 'none', strokeWidth: '2', strokeMiterlimit: '10' }) })) })) })));
};
export default Loader;
export var SpinnerLoader = function () {
    return (_jsxs("div", __assign({ className: "lds-spinner" }, { children: [_jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {})] })));
};



// WEBPACK FOOTER //
// ./src/components/Loader.jsx